import { Flag, ArrowRight, ArrowLeft, ChevronDown, CheckCircle, XCircle } from "lucide-react";
import React, { useEffect, useState } from "react";
// import StarterQuestionsDropDown from "../../../components/question-components/StarterQuestionsDropDown";
import "../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/StarterQuestions.css";
import axios from "axios";

const StarterQuestion = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const [answers, setAnswers] = useState({});
    const [submissionResult, setSubmissionResult] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [options, setOptions] = useState([]);
    const [page, setPage] = useState(0);
    const [limit] = useState(3);
    const [totalQuestions, setTotalQuestions] = useState(0);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [scoreCardResults, setScoreCardResults] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const userId = sessionStorage.getItem("userId");

    const fetchQuestions = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`/user/fetch-question?page=${page}&limit=${limit}`);
            setQuestions(response.data.questions);
            setOptions(response.data.combinedOptions);
            setTotalQuestions(response.data.totalCount);
            setAnswers({});
            if (isSubmitted) {
                setIsSubmitted(false);
                setSubmissionResult(null);
            }
        } catch (error) {
            console.error("Error fetching questions:", error);
            alert("An error occurred while fetching questions.");
        } finally {
            setIsLoading(false);
        }
    };

    const toggleDropdown = (index) => {
        setOpenDropdown(openDropdown === index ? null : index);
    };

    const selectAnswer = (questionIndex, selectedOption) => {
        setAnswers((prev) => ({
            ...prev,
            [questionIndex]: selectedOption,
        }));
        setOpenDropdown(null);
    };

    const handleSubmit = async () => {
        setIsSubmitted(true);

        const formattedAnswers = questions.map((q, index) => ({
            questionId: q._id,
            userAnswer: answers[index] || null,
        }));

        if (formattedAnswers.some((ans) => ans.userAnswer === null)) {
            alert("Please answer all questions before submitting.");
            return;
        }

        try {
            const response = await axios.post("/user/submit-question-answer", {
                questions: formattedAnswers,
                userId: userId,
            });

            if (response.status === 200) {
                setSubmissionResult(response.data);
                alert("Submission successful!");
                setScoreCardResults(prev => [...prev, ...response.data.results]);
            }
        } catch (error) {
            console.error("Submission error:", error);
            alert("An error occurred while submitting answers.");
        }
    };

    useEffect(() => {
        fetchQuestions();
    }, [page]);

    useEffect(() => {
        const storedScoreCard = localStorage.getItem('scoreCardResults');
        if (storedScoreCard) {
            setScoreCardResults(JSON.parse(storedScoreCard));
        }
    }, [])

    useEffect(() => {
        localStorage.setItem('scoreCardResults', JSON.stringify(scoreCardResults));
    }, [scoreCardResults])

    if (isLoading) {
        return <div>Loading questions...</div>;
    }

    return (
        <div className="container">
            <div className="Starter-Questions">
                <div className="Starter-Questions-header">
                    <ArrowLeft
                        onClick={() => page > 0 && setPage((prev) => prev - 1)}
                        className={`pagination-icon ${page === 0 ? "disabled" : ""}`}
                    />
                    <p>
                        Question {page * limit + 1}-{Math.min((page + 1) * limit, totalQuestions)} of {totalQuestions}
                    </p>
                    <Flag />
                    <ArrowRight
                        onClick={() => (page + 1) * limit < totalQuestions && setPage((prev) => prev + 1)}
                        className={`pagination-icon ${(page + 1) * limit >= totalQuestions ? "disabled" : ""}`}
                    />
                </div>
                <hr />
                <div>
                    <div className="Starter-Questions-questions">
                        <p>Theme: Causes of headache</p>
                        <ol>
                            {options.map((option, index) => (
                                <li key={index}>{option}</li>
                            ))}
                        </ol>
                    </div>
                    <div>
                        <p>For each one of the following clinical scenarios, select the most likely diagnosis:</p>
                        <ol>
                            {questions.map((question, index) => {
                                const questionResult = submissionResult?.results?.find((q) => q.questionId === question._id);
                                const isCorrect = questionResult?.isCorrect;

                                return (
                                    <li key={index} className="Starter-Questions-list">
                                        {question.questionText} {/* Ensure questionText is rendered here */}
                                        <div className="starter-question-dropdown-container">
                                            <button className="starter-question-dropdown-button" onClick={() => toggleDropdown(index)}>
                                                Option <ChevronDown size={16} />
                                            </button>
                                            {openDropdown === index && (
                                                <ul className="starter-question-dropdown-menu">
                                                    {options.map((option, idx) => (
                                                        <li key={idx} className="starter-question-dropdown-item" onClick={() => selectAnswer(index, option)}>
                                                            {option}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                        {answers[index] && (
                                            <p className="selected-answer">
                                                Selected Answer: {answers[index]}
                                            </p>
                                        )}
                                        {isSubmitted && (
                                            <p className={`selected-answer ${isCorrect ? "correct" : "incorrect"}`}>
                                                {isCorrect ? <CheckCircle color="green" size={16} /> : <XCircle color="red" size={16} />}
                                                {answers[index]}
                                            </p>
                                        )}
                                    </li>
                                );
                            })}
                        </ol>
                        <button className="Starter-Questions-button" onClick={handleSubmit}>
                            Submit
                        </button>
                    </div>
                </div>
            </div>
            <div className="score-card">
                <p>Score:</p>
                <hr />
                <p>1-{scoreCardResults.length}</p>
                {scoreCardResults.map((questionItem, index) => (
                    <div key={index} className="score-item">
                        <p>
                            Question {index + 1}: {questionItem.isCorrect ? <CheckCircle color="green" size={16} /> : <XCircle color="red" size={16} />}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StarterQuestion;